import { Button, Typography } from "@blofin/blofin-ui";
import { useStoreState } from "../store/useStore";
import { useTranslations } from "use-intl";
import AssetsPopper from "../AssetsPopper";
import OverviewPopper from "../OverviewPopper";
import NewUserBanner from "./NewUserBanner";
import GiftIcon from "@/nav-localized/assets/header/nav/gift.svg?react";

import NotificationPopper from "../NotificationPopper";
import DepositDrawer from "../DepositDrawer";
import NotificationIcon from "@/nav-localized/assets/header/notification.svg?react";
import { stylesText } from "../styles";
import clsx from "clsx";

// 配置
import { showNewUserBanner } from "@/nav-localized/config";

const User = () => {
  const { hideSignUpAndLogIn, isLogin, theme, localeLink } = useStoreState();

  const t = useTranslations("header");

  /**
   * 检查当前路由是否为 task-center
   */
  const isTaskCenterRoute = () => {
    const router = window.next?.router;
    if (!router) return false;

    // 检查路由是否包含 task-center
    return router?.asPath?.includes?.("task-center");
  };

  const getCurrentUrl = (url: string) => {
    const router = window.next?.router;
    const notNextjs = router?.notNextjs;
    if (notNextjs) {
      return `${localeLink}/${url}`;
    }

    if (!router) {
      return "";
    }

    const basePath = router.basePath && router.basePath !== "/" ? router.basePath : "";
    const asPath = router.asPath || "/";

    const buildRedirectPath = () => {
      if (asPath === "/") {
        return `${basePath}${localeLink}/`.replace(/\/{2,}/g, "/");
      }

      const normalizedAsPath = asPath.startsWith("/") ? asPath : `/${asPath}`;
      // 只对 pathname 做斜杠压缩，保留 query/hash 中合法的 //（如嵌套 URL 参数）
      const splitIdx = normalizedAsPath.search(/[?#]/);
      const pathPart = splitIdx === -1 ? normalizedAsPath : normalizedAsPath.slice(0, splitIdx);
      const qsPart = splitIdx === -1 ? "" : normalizedAsPath.slice(splitIdx);
      return `${basePath}${localeLink}${pathPart}`.replace(/\/{2,}/g, "/") + qsPart;
    };

    if (router.asPath === "/") {
      return `${localeLink}/${url}?redirect=${encodeURIComponent(buildRedirectPath())}`;
    }

    const refCode =
      router.query?.referral_code &&
      typeof router.query.referral_code === "string" &&
      router.asPath.includes(`?referral_code=`)
        ? `referral_code=${router.query.referral_code}&`
        : "";

    return `${localeLink}/${url}?${refCode}redirect=${encodeURIComponent(buildRedirectPath())}`;
  };

  if (isLogin === null) {
    return null;
  }

  return (
    <div className="flex items-center h-full">
      {!isLogin ? (
        hideSignUpAndLogIn ? null : (
          <>
            <a className="max-[600px]:hidden" href={getCurrentUrl("login")}>
              <Button
                variant="text"
                size="small"
                className="font-medium"
                id="header_login_in"
                theme={theme}
              >
                <Typography
                  theme={theme}
                  variant="body3"
                  className={clsx(
                    "font-medium text-[14px]",
                    theme === "dark" ? "hover:text-dark-primary" : "hover:text-light-primary"
                  )}
                >
                  {t("login")}
                </Typography>
              </Button>
            </a>
            <a href={getCurrentUrl("register")}>
              <Button
                variant="primary"
                size="small"
                className="font-medium w-auto h-[32px] text-[14px] leading-[20px]"
                id="header_sign_up"
                theme={theme}
              >
                <GiftIcon className="mr-2 h-[18px] w-auto" />
                {t("signup")}
              </Button>
            </a>
            <a
              className={clsx(
                "max-[600px]:hidden",
                "h-full ml-[24px] flex items-center",
                stylesText({ mode: theme }),
                theme === "dark" ? "hover:text-dark-primary" : "hover:text-light-primary"
              )}
              href={getCurrentUrl("login")}
            >
              <NotificationIcon className={clsx("w-[24px] h-[24px]")} />
            </a>
          </>
        )
      ) : (
        <div className="flex">
          {isLogin && !isTaskCenterRoute() && showNewUserBanner && (
            <NewUserBanner className="mr-[16px] my-auto" localeLink={localeLink} />
          )}
          <DepositDrawer />
          <AssetsPopper />
          <OverviewPopper />
          <NotificationPopper />
        </div>
      )}
    </div>
  );
};

export default User;
